<template>
  <transition name="drawer-fade">
    <div v-if="visible" class="custom-drawer-wrapper">
      <div class="drawer-overlay" @click="handleClose"></div>
      <div class="drawer-container">
        <div class="drawer-custom-header">
          <i class="el-icon-close close-btn" @click="handleClose"></i>
          <span class="header-title">{{ headerTitle }}</span>
        </div>
        <div class="drawer-body-scroll">
          <el-timeline v-if="histories.length">
            <el-timeline-item
              v-for="entry in histories"
              :key="entry.id"
              hide-timestamp
              type="primary"
            >
              <div class="history-item">
                <div class="history-item__head">
                  <span class="history-item__time">{{ entry.createdAt | formatDate('dateTime') }}</span>
                  <el-tag
                    v-if="tagKey(entry)"
                    class="history-action-tag"
                    :style="getActionTagStyle(entry)"
                  >
                    {{ getActionMeta(entry).label }}
                  </el-tag>
                </div>
                <div v-if="mainLine(entry)" class="history-item__main">{{ mainLine(entry) }}</div>
                <div v-if="entry.reason" class="history-item__reason">{{ formatReason(entry) }}</div>
              </div>
            </el-timeline-item>
          </el-timeline>
          <div v-else class="empty-state">暫無歷史紀錄</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import formatDate from '@utils/format-date'
import {
  formatHistoryMainLine,
  formatHistoryReason,
  resolveHistoryActionMeta,
  resolveHistoryTagKey,
} from '@/src/router/views/schedule/hotel/enums/historyActionMap'

export default {
  name: 'OrderHistoryDrawerPartial',
  filters: {
    formatDate,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    histories: {
      type: Array,
      default: () => [],
    },
    orderDisplayId: {
      type: String,
      default: '',
    },
  },
  computed: {
    headerTitle() {
      const orderNo = String(this.orderDisplayId || '').trim()
      return orderNo ? `${orderNo} 操作紀錄` : '操作紀錄'
    },
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    tagKey(entry) {
      return resolveHistoryTagKey(entry)
    },
    getActionMeta(entry) {
      return resolveHistoryActionMeta(entry?.action, entry?.status)
    },
    getActionTagStyle(entry) {
      const meta = resolveHistoryActionMeta(entry?.action, entry?.status)
      return {
        backgroundColor: meta.color,
        borderColor: meta.color,
        color: meta.textColor,
        borderRadius: '8px',
      }
    },
    mainLine(entry) {
      return formatHistoryMainLine(entry)
    },
    formatReason(entry) {
      return formatHistoryReason(entry?.reason, entry?.action)
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-drawer-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  display: flex;
  justify-content: flex-end;
}

.drawer-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  cursor: pointer;
  z-index: 0;
}

.drawer-container {
  position: relative;
  width: 45%;
  min-width: 500px;
  height: 100%;
  background: #f9f9fb;
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  z-index: 1;
}

.drawer-custom-header {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #f2f2f2;
  background: #f9f9f9;
  flex-shrink: 0;

  .close-btn {
    font-size: 32px;
    cursor: pointer;
    margin-right: 15px;
    color: #121931;

    &:hover {
      color: #ea6a2a;
    }
  }

  .header-title {
    color: #000000;
    font-weight: 900;
    font-size: 18px;
  }
}

.drawer-body-scroll {
  padding: 16px 24px;
  padding-bottom: 50px;
  flex: 1;
  overflow-y: auto;
  background: #f9f9fb;

  ::v-deep .el-timeline {
    padding-left: 4px;
  }

  ::v-deep .el-timeline-item {
    padding-bottom: 24px;

    &__node {
      top: 10px;
      left: 1px;
    }

    &__tail {
      top: 24px;
      left: 6px;
    }

    &__wrapper {
      top: 0;
      padding-left: 22px;
    }

    &__content {
      padding-top: 0;
      margin-top: -2px;
    }
  }
}

.history-item {
  line-height: 1.5;

  &__head {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    min-height: 24px;
  }

  &__time {
    font-size: 14px;
    line-height: 24px;
    color: #6c6b6b;
  }

  &__main {
    margin-top: 6px;
    color: #121931;
    font-size: 14px;
    line-height: 1.5;
  }

  &__reason {
    margin-top: 4px;
    color: #6c6b6b;
    font-size: 14px;
    line-height: 1.5;
  }
}

.history-action-tag {
  height: 24px;
  line-height: 22px;
  padding: 0 8px;
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: #6c6b6b;
  font-size: 16px;
}

.drawer-fade-enter-active,
.drawer-fade-leave-active {
  transition: opacity 0.3s;

  .drawer-container {
    transition: transform 0.3s ease;
  }
}

.drawer-fade-enter,
.drawer-fade-leave-to {
  opacity: 0;

  .drawer-container {
    transform: translateX(100%);
  }
}
</style>
